import { createRouter, createWebHistory } from '@ionic/vue-router';
import LoginPage from '../views/LoginPage.vue';
import RegisterPage from '../views/RegisterPage.vue';
import CalendarPage from '../views/CalendarPage.vue'
import UserSettings from '@/views/UserSettings.vue'
import ProfileSettings from '@/views/ProfileSettings.vue'
import DashboardPage from '@/views/DashboardPage.vue'
import TransactionPage from '@/views/TransactionPage.vue'
import CreateScenarioPage from '@/views/CreateScenarioPage.vue'
import DeleteScenarioPage from '@/views/DeleteScenarioPage.vue'
import FeedbackPage from '@/views/FeedbackPage.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: CalendarPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/user-settings',
    name: 'UserSettings',
    component: UserSettings,
    meta: { requiresAuth: true }
  },
  {
    path: '/transaction',
    name: 'Transaction',
    component: TransactionPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile-settings',
    name: 'ProfileSettings',
    component: ProfileSettings,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-scenario',
    name: 'CreateScenario',
    component: CreateScenarioPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/delete-scenario',
    name: 'DeleteScenario',
    component: DeleteScenarioPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: FeedbackPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/dashboard'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const token = localStorage.getItem('token')

  if (requiresAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router; 